<template>
  <div class="page">
    <h3 v-if="!hideTitle">광고캐시백 조회 - 고객 조회</h3>

    <div class="toolbar">
      <!-- 20006 검색조건 배치도: "센터" 에디트 + 검색(센터 검색 팝업) / "이름" 에디트 + 검색(회원 검색 팝업) / 조회(청색) -->
      <!-- 20006: 센터명/이름 에디트는 모든 role 비활성(검색 팝업으로만 채움), placeholder 없음 -->
      <label>센터</label>
      <!-- 센터, 이름 조회 입력받기 프로젝트 -->
      <input v-model="centerName" type="text" class="cust-in narrow" @keyup.enter="reload" />
      <button class="ghost" @click="centerSearchOpen=true">검색</button>
      <button class="ghost" @click="centerName=''">비우기</button>
      <label>이름</label>
      <!-- 센터, 이름 조회 입력받기 프로젝트 -->
      <input v-model="custName" type="text" class="cust-in narrow" @input="custLoginId=''" @keyup.enter="reload" />
      <button class="ghost" @click="searchOpen=true">검색</button>
      <button class="ghost" @click="custName=''; custLoginId=''">비우기</button>
      <button class="search-btn" @click="reload">조회</button>
      <!-- 20006: role=customer 안내 문구 -->
      <span v-if="isCustomer" class="cust-note">※ 센터, 이름 비우기 클릭 후 조회 시 자신 및 자신 이하 전체 회원 검색됨</span>
      <span class="spacer"></span>
      <button class="ghost" @click="treeOpen=true">후원 조직도</button>
      <button class="ghost" @click="referralOpen=true">추천 조직도</button>
      <button v-if="canViewAll" class="ghost" @click="referralAdminOpen=true">추천 조직도 (관리자)</button>
      <!-- 개선2_61: 멤버쉽 캐시백 지도(관리자) -->
      <button v-if="canViewAll" class="ghost" @click="memTreeOpen=true">멤버쉽 캐시백 지도(관리자)</button>
      <!-- 요청: 업로드 버튼은 admin role 만 표시 -->
      <button v-if="admin" class="ghost" @click="importOpen=true">업로드</button>
      <button class="ghost" @click="exportExcel">다운로드</button>
      <!-- 스펙234_개선_34: [추가] 버튼은 모든 role 에서 감춘다. 맨 우측에 수정 버튼. -->
      <button class="edit-btn" @click="editSelected">수정</button>
    </div>

    <!-- 노드(본체+아바타) 정보 표시. 가로가 길면 가로 스크롤바 생성 -->
    <div class="table-scroll">
      <table class="grid">
        <thead>
          <tr>
            <th class="center">선택</th>
            <th>소속 센터</th>
            <th>로그인ID</th><th>주문사용자ID</th><th>이름</th><th>직급</th>
            <th>후원인</th><th>추천인</th>
          </tr>
        </thead>
        <tbody>
          <!-- 비노출: 식별자(id), 비밀번호. 각 행 = 노드(본체 또는 아바타) -->
          <tr v-for="row in list" :key="row.nodeId" :class="{ sel: selectedId === row.nodeId }" @click="selectedId = row.nodeId">
            <td class="center">
              <input type="radio" name="custPick" :value="row.nodeId" v-model="selectedId" @click.stop />
            </td>
            <td>{{ row.centerName || '-' }}</td>
            <td>{{ row.loginId }}</td>
            <!-- 스펙234_개선_34: 주문사용자ID 는 모든 role 에서 수정 불가(편집 팝업/아이콘 제거) -->
            <td>{{ row.orderUserId || '-' }}</td>
            <td>{{ row.name }}</td>
            <td><span class="rank">{{ row.rankName || '그린스타' }}</span></td>
            <td>{{ sponsorLabel(row.sponsorName, row.sponsorLogin) }}</td>
            <td>{{ sponsorLabel(row.referrerName, row.referrerLogin) }}</td>
          </tr>
          <tr v-if="list.length===0"><td colspan="8" class="empty">데이터가 없습니다.</td></tr>
        </tbody>
      </table>
    </div>

    <Paging :page="page" :size="size" :total-count="totalCount" :total-pages="totalPages"
            @change-page="onPage" @change-size="onSize" />

    <CustomerAddDialog v-if="addOpen" @close="addOpen=false" @saved="onAddSaved" />
    <ExcelImportDialog v-if="importOpen" @close="importOpen=false" @imported="reload" />
    <CustomerEditDialog v-if="editOpen" :owner="editOwner"
                        @close="editOpen=false" @saved="onEditSaved" />
    <!-- 20006: My Page (고객 정보) 팝업 -->
    <MyPageDialog v-if="myPageOpen" :customer-id="myPageCustomerId"
                  @saved="onMyPageSaved" @close="myPageOpen=false" />
    <PositionTreeDialog v-if="treeOpen" @close="treeOpen=false" />
    <!-- 개선2_61: 멤버쉽 캐시백 지도(관리자) -->
    <PositionTreeDialog v-if="memTreeOpen" :membership="true" @close="memTreeOpen=false" />
    <ReferralTreeDialog v-if="referralOpen" @close="referralOpen=false" />
    <ReferralTreeDialog v-if="referralAdminOpen" :admin="true" @close="referralAdminOpen=false" />
    <!-- 20006: 회원 검색은 분리 팝업 사용(customer 도 admin 에러 없이 자기 자식 검색 가능) -->
    <SettlementMemberSearchDialog v-if="searchOpen" :self-children-only="!canViewAll" @select="onPick" @close="searchOpen=false" />
    <!-- 20006: 센터 검색 팝업 -->
    <SettlementCenterSearchDialog v-if="centerSearchOpen" :self-children-only="!canViewAll" @select="onPickCenter" @close="centerSearchOpen=false" />
    <OrderUserIdEditDialog v-if="ouidOpen" :customer-id="ouidCustomerId" @saved="load" @close="ouidOpen=false" />
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import api from '../api';
import { isAdmin, canViewAll } from '../store/auth';
import Paging from '../components/Paging.vue';
import ExcelImportDialog from '../components/ExcelImportDialog.vue';
import CustomerEditDialog from '../components/CustomerEditDialog.vue';
import MyPageDialog from '../components/MyPageDialog.vue';
import CustomerAddDialog from '../components/CustomerAddDialog.vue';
import PositionTreeDialog from '../components/PositionTreeDialog.vue';
import ReferralTreeDialog from '../components/ReferralTreeDialog.vue';
import SearchDialog from '../components/SearchDialog.vue';
import SettlementMemberSearchDialog from '../components/SettlementMemberSearchDialog.vue';
import SettlementCenterSearchDialog from '../components/SettlementCenterSearchDialog.vue';
import OrderUserIdEditDialog from '../components/OrderUserIdEditDialog.vue';

export default {
  name: 'CustomerInquiry',
  components: { Paging, ExcelImportDialog, CustomerEditDialog, MyPageDialog, CustomerAddDialog, PositionTreeDialog, ReferralTreeDialog, SearchDialog, SettlementMemberSearchDialog, SettlementCenterSearchDialog, OrderUserIdEditDialog },
  props: { hideTitle: { type: Boolean, default: false } },   // 스펙234_개선_13: 결합화면 임베드 시 타이틀 숨김
  data() {
    return {
      list: [], page: 1, size: 10, totalCount: 0, totalPages: 0, custName: '', custLoginId: '',
      centerName: '', centerSearchOpen: false,   // 20006: 센터명 검색조건 + 센터 검색 팝업
      searchOpen: false,   // 회원 검색 팝업
      ouidOpen: false, ouidCustomerId: null,   // 스펙234_개선_30: 주문사용자ID 편집
      importOpen: false, addOpen: false, editOpen: false, treeOpen: false, memTreeOpen: false, referralOpen: false, referralAdminOpen: false,
      editOwner: {}, selectedId: null,
      myPageOpen: false, myPageCustomerId: null,
      admin: isAdmin(),                             // v112: 업로드 버튼은 admin 전용 (staff·customer 미표시)
      canViewAll: canViewAll(),                      // 스펙211: 추천 조직도(관리자) 버튼 = staff/admin
      isCustomer: !canViewAll()                      // 20006: customer 는 센터명/이름 에디트 비활성(검색/비우기 버튼은 활성)
    };
  },
  created() {
    // 20006: 진입 시 센터명/이름 칸 비우기(모든 role). 리스트는 백엔드 스코프(customer=자신+자식)로 조회.
    this.reload();
  },
  methods: {
    // 회원 검색 팝업에서 고객 선택 → 이름 표시 + login_id 확보(그 회원만 정확 조회).
    onPick(sel) {
      this.custName = sel.name || '';
      this.custLoginId = sel.loginId || '';
      this.searchOpen = false;
      this.reload();
    },
    // 센터 검색 팝업에서 센터 선택 → 센터명 입력란 채우고 조회
    onPickCenter(c) {
      this.centerName = (c && c.centerName) || '';
      this.centerSearchOpen = false;
      this.reload();
    },
    // 스펙234_개선_30: 주문사용자ID 편집 팝업 (staff/admin 만)
    openOrderUid(row) {
      if (!this.canViewAll) return;
      this.ouidCustomerId = row.customerId;
      this.ouidOpen = true;
    },
    async load() {
      // 스펙23: 노드(본체+아바타) 기반 목록
      //센터, 이름 조회 입력받기 프로젝트
      const res = await api.nodes({ page: this.page, size: this.size, custLoginId: this.custLoginId, 
        custName: this.custName.trim(), centerName: this.centerName.trim() });
      this.list = res.data.list;
      this.totalCount = res.data.totalCount;
      this.totalPages = res.data.totalPages;
      // 현재 페이지에 선택 행이 없으면 선택 해제
      if (!this.list.some(r => r.nodeId === this.selectedId)) this.selectedId = null;
    },
    reload() { this.page = 1; this.load(); },
    onPage(p) { this.page = p; this.load(); },
    onSize(s) { this.size = s; this.page = 1; this.load(); },
    // "이름(로그인id)" 형태, 없으면 '-'
    sponsorLabel(name, login) {
      if (!login && !name) return '-';
      return (name || '') + (login ? '(' + login + ')' : '');
    },
    // 라디오 선택 후 수정 버튼 → 선택 노드의 수정 팝업 진입
    //   스펙39: 본체/아바타 동일한 수정 팝업(CustomerEditDialog). 노드 정보를 함께 전달.
    editSelected() {
      if (this.selectedId == null) { window.alert('수정할 노드를 먼저 선택하세요.'); return; }
      const row = this.list.find(r => r.nodeId === this.selectedId);
      if (!row) { window.alert('선택한 노드를 찾을 수 없습니다.'); return; }
      // 20006: 고객 정보 수정 팝업 → My Page
      this.myPageCustomerId = row.customerId;
      this.myPageOpen = true;
    },
    onEditSaved() { this.load(); },
    onMyPageSaved() { this.myPageOpen = false; this.load(); },
    onAddSaved() { this.addOpen = false; this.load(); },
    async exportExcel() {
      // 화면(노드 목록) 내용을 엑셀로 저장
      //센터, 이름 조회 입력받기 프로젝트
      const res = await api.nodes({ page: 1, size: 100000, custLoginId: this.custLoginId, 
        custName:this.custName.trim(), centerName: this.centerName.trim() });
      // 스펙233: 다운로드 엑셀 1 row(헤더) = 업로드 양식과 동일한 컬럼/순서
      //   센터코드, 로그인id, 이름, 추천인id, 후원인id (2 row 부터 해당 데이터). 센터/추천인/후원인은 ID 값 출력.
      const list = (res.data && res.data.list) || [];
      const header = ['센터코드', '로그인id', '이름', '추천인id', '후원인id'];
      const aoa = [header].concat(list.map(r => [
        (r.centerId !== undefined && r.centerId !== null) ? r.centerId : '',
        r.loginId || '',
        r.name || '',
        r.referrerLogin || '',
        r.sponsorLogin || ''
      ]));
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '고객목록');
      XLSX.writeFile(wb, 'customers.xlsx');
    }
  }
};
</script>

<style scoped>
.page { background: #fff; padding: 20px; border-radius: 8px; }
h3 { margin: 0 0 16px; }
.toolbar { display: flex; gap: 8px; align-items: center; margin-bottom: 14px; }
.toolbar .spacer { flex: 1; }
.toolbar input { padding: 7px 9px; border: 1px solid #d0d5dd; border-radius: 5px; }
.toolbar .cust-in { min-width: 180px; }
.toolbar .cust-in.narrow { min-width: 110px; width: 110px; }
.toolbar .cust-note { font-size: 12px; color: #c0392b; margin-left: 6px; }
.toolbar label { font-size: 13px; color: #555; }
.toolbar .cust-in:disabled { background: #f2f4f7; color: #667085; }
.toolbar button { padding: 7px 16px; background: #2f6fed; color: #fff; border: none; border-radius: 5px; cursor: pointer; }
.toolbar button.ghost { background: #eef1f7; color: #33415c; }
.toolbar button.add-btn { background: #2e8b57; color: #fff; }
.toolbar button.edit-btn { background: #2f6fed; color: #fff; }
/* 스펙234_개선_35: 검색조건 청색 [조회] 버튼 */
.toolbar button.search-btn { background: #2f6fed; color: #fff; }
.table-scroll { overflow-x: auto; }
.grid { width: 100%; border-collapse: collapse; min-width: 760px; }
.grid th, .grid td { border: 1px solid #e5e8ef; padding: 8px 10px; font-size: 13px; white-space: nowrap; }
.grid th { background: #f0f3fa; color: #33415c; }
.grid td.center, .grid th.center { text-align: center; }
.grid tbody tr { cursor: pointer; }
.grid tbody tr.sel { background: #eef5ff; }
.rank { display: inline-block; padding: 2px 8px; background: #eef3ff; color: #2f6fed; border-radius: 10px; font-size: 12px; }
.grid td.ouid { color: #2f6fed; cursor: pointer; white-space: nowrap; }
.grid td.ouid:hover { text-decoration: underline; }
.grid td.ouid .pen { margin-left: 4px; color: #98a6c0; font-size: 11px; }
.empty { text-align: center; color: #999; padding: 20px; }
</style>
